import {Link, useLocation, useNavigate} from "react-router-dom";
import Box from "@mui/material/Box";
import Tabs from "@mui/material/Tabs";
import Tab from "@mui/material/Tab";
import {useRouteMatch} from "utils/functions";
import PageTitle from "shared/ui/PageTitle";
import GenericButton from "shared/ui/GenericButton";
import BoxContent from "shared/ui/BoxContent";
import BrioTags from "../components/BrioTags";
import UserTags from "../components/UserTags";

const TestTags = () => {
    const navigate = useNavigate();
    const location = useLocation();

    const ROUTES = {
        brio: "/taguri",
        userAdded: "/taguri/taguri-adaugate",
        add: "/taguri/adauga",
    };

    const tabs = [
        { label: "Taguri Brio", value: ROUTES.brio },
        { label: "Taguri adaugate", value: ROUTES.userAdded },
    ];

    const activeTab = useRouteMatch(tabs.map((t) => t.value)) || ROUTES.brio;

    const tabSx = { color: "secondary.light", "& :hover, & .active": "primary.main" };

    const contentByPath: Record<string, JSX.Element> = {
        [ROUTES.brio]: <BrioTags />,
        [ROUTES.userAdded]: <UserTags />,
    };

    const activePath = location.pathname;

    return (
        <Box component="main">
            <PageTitle
                actions={<GenericButton type="add" onClick={() => navigate(ROUTES.add)} />}
            >
                Taguri
            </PageTitle>
            <BoxContent>
                <Box sx={{ width: "100%" }}>
                    <Box mb={2} sx={{ borderBottom: 1, borderColor: "divider" }}>
                        <Tabs
                            value={activeTab}
                            sx={{"& .MuiTabs-flexContainer": {flexWrap: "wrap"}}}
                        >
                            {tabs.map((tab) => (
                                <Tab
                                    key={tab.value}
                                    label={tab.label}
                                    value={tab.value}
                                    to={tab.value}
                                    component={Link}
                                    sx={tabSx}
                                />
                            ))}
                        </Tabs>
                    </Box>
                    {contentByPath[activePath] ?? null}
                </Box>
            </BoxContent>
        </Box>
    );
}

export default TestTags;